import { useContext, useState, useEffect } from "react";
import { MainContext } from "../../../../MainContext";
import { request } from "../../../../request";
import CreatableSelect from "react-select/creatable";
import CurrencyInputs from "./CurrencyInputs";
import Swal from "sweetalert2";
import { Box, Button, Card, CardContent, CardMedia, Grid, IconButton } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";

const AddAccount = ({ setShowAddAcc }) => {
    const [accName, setAccName] = useState("");
    const [accType, setAccType] = useState("");
    const [currencies, setCurrencies] = useState([{ currency_name: "", avg: 0, value: 0 }]);
    const [selectedImage, setSelectedImage] = useState(null);
    const { darkMode, updateAccounts, updateCapital, updateUsers, accountTypes, updateAccountTypes, texts } = useContext(MainContext);

    const handleImageChange = (e) => {
        setSelectedImage(e.target.files[0]);
    };

    const handleRemoveImage = () => {
        setSelectedImage(null);
    };

    const addCurrency = () => {
        setCurrencies([...currencies, { currency_name: "", avg: 0, value: 0 }]);
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const formData = new FormData();
            formData.append("name", accName);
            formData.append("currencies", JSON.stringify(currencies));
            formData.append("type", accType);

            if (selectedImage) {
                formData.append("icon", selectedImage);
            }

            await request.post("/account/", formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });
            Swal.fire({
                title: "Account added successfully",
                icon: "success",
            });
            setCurrencies([]);
            setAccName("");
            setShowAddAcc(false);
            updateCapital();
            updateAccounts();
            updateUsers();
        } catch (error) {
            console.log(error);
        }
    };

    // Add New Value
    const addNewAccountType = async (type) => {
        console.log(type);
        if (type !== null) {
            try {
                await request.post("/account/type", {
                    name: type,
                    priority: 1,
                });
                updateAccountTypes();
                setAccType(type);
            } catch (error) {
                console.log(error);
            }
        }
    };

    const options = accountTypes.map((option) => ({
        value: option.name,
        label: option.name,
    }));

    const createableSelectStyles = {
        control: (base) => ({
            ...base,
            borderColor: "gray",
            borderRadius: "0.375rem",
            padding: "0.375rem",
            boxShadow: "none",
            "&:hover": {
                borderColor: "blue",
            },
        }),
        option: (base, state) => ({
            ...base,
            backgroundColor: state.isSelected ? "blue" : state.isFocused ? "lightgray" : "white",
            color: state.isSelected ? "white" : "black",
            "&:hover": {
                backgroundColor: "lightblue",
            },
        }),
        menu: (base) => ({
            ...base,
            marginTop: 0,
            borderRadius: "0.375rem",
        }),
        placeholder: (base) => ({
            ...base,
            color: "gray",
            fontSize: "0.875rem",
        }),
    };
    return (
        <div
            className="container mx-auto p-6 max-w-[960px] rounded-lg shadow-lg"
            style={{
                backgroundColor: darkMode ? "#000" : "white",
                borderRadius: "20px",
            }}
        >
            <form className="mb-4" onSubmit={handleSubmit}>
                <div className="flex flex-col mb-4 py-3 mt-5">
                    <label className="text-lg mb-2 font-bold leading-normal tracking-[0.015em]" htmlFor="name">
                        <input
                            type="text"
                            id="name"
                            value={accName}
                            onChange={(e) => setAccName(e.target.value)}
                            className="form-input flex w-full min-w-0 flex-1 resize-none overflow-hidden rounded-xl text-[#111418] focus:outline-0 focus:ring-0 border border-[#dce0e5] bg-white focus:border-[#dce0e5] h-14 placeholder:text-[#637588] p-[15px] text-base font-normal leading-normal"
                            placeholder={texts.account.accountName}
                            required
                        />
                        <label className="flex flex-col min-w-40 flex-1" style={{ marginTop: "21px" }}>
                            <CreatableSelect
                                isClearable
                                options={options}
                                onChange={(e) => (e !== null ? setAccType(e.label) : "")}
                                value={accType ? { label: accType } : ""}
                                onCreateOption={(e) => addNewAccountType(e)}
                                styles={createableSelectStyles}
                                placeholder={texts.account.accountType}
                                name="account-type"
                            />
                        </label>
                    </label>
                </div>
                <h3 className="text-xl font-bold leading-normal tracking-[0.015em]" style={{ color: darkMode ? "white" : "black" }}>
                    {texts.account.currencies}
                </h3>
                <div className="currencies">
                    {/* Dropdown for existing options */}

                    {currencies.map((e, index) => {
                        const setValue = (new_value) => {
                            const newCurrencies = [...currencies];
                            newCurrencies[index] = new_value;
                            setCurrencies(newCurrencies);
                        };
                        const removeMe = () => {
                            const newCurrencies = [...currencies];
                            newCurrencies.splice(index, 1);
                            setCurrencies(newCurrencies);
                        };
                        return <CurrencyInputs selected_currencies={currencies} remove={removeMe} index={index} setValue={setValue} texts={texts} />;
                    })}
                    <div class="flex justify-start">
                        <button type="button" class="flex min-w-[84px] mt-5 max-w-[480px] cursor-pointer items-center justify-center overflow-hidden rounded-xl h-10 p-5 bg-[#333] text-[#fff] text-sm font-bold leading-normal tracking-[0.015em] " onClick={addCurrency}>
                            <span class="truncate">+ {texts.account.currency}</span>
                        </button>
                    </div>
                </div>
                <>
                    <Button
                        variant="outlined"
                        component="label"
                        sx={{
                            mt: 5,
                            mb: 3,
                            color: "white",
                            borderColor: "white",
                            "&:hover": {
                                backgroundColor: "white",
                                color: "black",
                            },
                        }}
                    >
                        + {texts.account.uploadIcon}
                        <input type="file" hidden multiple accept="image/*" onChange={handleImageChange} />
                    </Button>
                    <Grid item xs={2}>
                        {selectedImage ? (
                            <Card sx={{ width: "150px", height: "auto" }}>
                                <CardMedia component="img" width="10" height="10" image={URL.createObjectURL(selectedImage)} />
                                <CardContent sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center", height: "50px", p: 1 }}>
                                    <IconButton color="secondary" sx={{ marginTop: "15px" }} onClick={handleRemoveImage}>
                                        <DeleteIcon />
                                    </IconButton>
                                </CardContent>
                            </Card>
                        ) : (
                            ""
                        )}
                    </Grid>
                </>

                {/* Input and button to add new option */}

                <button
                    type="submit"
                    class="flex min-w-[84px] mt-5 cursor-pointer items-center justify-center overflow-hidden rounded-xl h-10 px-4 bg-[#f0f2f4] text-[#111418] text-sm font-bold leading-normal tracking-[0.015em]"
                    style={{
                        backgroundColor: darkMode ? "#FEC901" : "#FEC901",
                        width: "100%",
                    }}
                >
                    <span class="truncate">{texts.account.addAccount}</span>
                </button>
            </form>
        </div>
    );
};

export default AddAccount;
